import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService } from "../../../../auth/service";
import { CommunicationsService } from "../../../../auth/service/communications.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { TutorialService } from "../../../../auth/service/tutorial.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-notification-user-list",
  templateUrl: "./notification-user-list.component.html",
  styleUrls: ["./notification-user-list.component.scss"],
})
export class NotificationUserListComponent implements OnInit {
  public contentHeader: IContentHeader;

  public notificationsList: any = [];

  public searchKeyword: string = "";
  public categories: any = [];
  public selectedCategory: string = "all";
  public selectedCommunication: any;
  public pageBasicText: any = 1;
  public pageSize = 10;
  public today: any = moment();
  public me: ICurrentUser;
  public idFromNotifications: string = "";

  public notificationLoaded: boolean = false;

  public filteredNotifications: any = [];

  public intervalNotificationsCheck: any;

  public filterRead: number = 0;

  public notificationToSetAsRead: any[] = [];

  @ViewChild("openNotification") mymodal: ElementRef;

  constructor(
    @Inject(DOCUMENT) private _document: any,
    public _communicationService: CommunicationsService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.NOTIFICATIONS_USER,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.NOTIFICATIONS_USER,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();
    this.intervalNotificationsCheck = setInterval(() => {
      if (this._communicationService.myNotifications.length > 0 || this._communicationService.myNotificationsLoaded) {
        this.notificationsList = this._communicationService.myNotifications;
        this.notificationLoaded = true;
        this.activatedRoute.queryParamMap.subscribe(async ({ params }: any) => {
          if (params.id) {
            this.filterRead = 0;
            this.selectedCategory = "all";
            this.searchKeyword = "";
            await this.filterNotifications();
            this.idFromNotifications = params.id;
            await this.modalOpen(this.mymodal, Number(this.idFromNotifications));
          }
        });
        clearInterval(this.intervalNotificationsCheck);
      }
    }, 100);
    this.categories = await this._communicationService.getListCategories();
    this.filterNotifications();
    this._utilService.hideLoading();
  }

  filterNotifications() {
    let items: any = this.filterRead == 1 ? this._communicationService.myNotificationOld : this._communicationService.myNotifications;
    const keywords: string = this.searchKeyword.trim().toLowerCase();
    const category: string = this.selectedCategory.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item?.title.toLowerCase().includes(keywords));
    }
    if (category.length > 0 && category !== "all") {
      items = items.filter((item: any) => item?.category?.toLowerCase().includes(category));
    }
    this.filteredNotifications = items;
  }

  async modalOpen(modalBasic: any, selectedNotifcation: number) {
    if (!this.filteredNotifications || this.filteredNotifications.length < 1) {
      return false;
    }

    if (selectedNotifcation) {
      this.selectedCommunication = this.filteredNotifications.find((communication) => communication.id === selectedNotifcation);

      if (!this.selectedCommunication) {
        if (window.location.search.includes("id=")) {
          window.history.pushState({}, "", window.location.pathname);
        }
        return false;
      }
    }

    this._modalService.open(modalBasic, {
      size: "l",
      centered: true,
      backdrop: false,
      keyboard: false,
    });

    if (this.selectedCommunication) {
      this.selectedCommunication.send_date = moment(this.selectedCommunication.send_date);

      this.selectedCommunication.text = this.selectedCommunication.text.replace(/hide-on-platform/g, "d-none");

      if (this.selectedCommunication.related_url) {
        this.selectedCommunication.related_url = this.selectedCommunication.related_url.replace("%3F", "?");
      }
      if (!this.selectedCommunication.read) {
        await this._communicationService.setRead([selectedNotifcation]).then(async () => {
          await this._communicationService.getMine().then(() => this.filterNotifications());
        });
      }
    }
  }

  modalClose() {
    this._modalService.dismissAll();
    this.router.navigateByUrl("/dashboard/notifications");
  }

  changeReadStatus() {
    setTimeout(async () => {
      this.notificationLoaded = false;
      if (this.filterRead == 1) {
        if (this._communicationService.myNotificationOld.length < 1 && !this._communicationService.myNotificationOldLoaded) {
          await this._communicationService.getMineOld();
        }
      }
      this.notificationLoaded = true;
      this.filterNotifications();
    });
  }

  toggleToNotificationsToRead(id: number) {
    if (this.notificationToSetAsRead.includes(id)) {
      this.notificationToSetAsRead = this.notificationToSetAsRead.filter((notification: number) => notification !== id);
    } else {
      this.notificationToSetAsRead.push(id);
    }
  }

  async setNotificationsAsReaded() {
    if (this.notificationToSetAsRead && this.notificationToSetAsRead.length > 0) {
      this._utilService.showLoading();
      await this._communicationService
        .setRead(this.notificationToSetAsRead)
        .then(async () => {
          await this._communicationService.getMine().then(() => this.filterNotifications());
          this.notificationToSetAsRead = [];
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_NOTIFICATION_SET_READ" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_NOTIFICATION_SET_READ" });
        });
    }
  }

  selectAllNotification(selectAll: boolean) {
    if (selectAll) {
      this.filteredNotifications.map((notification) => {
        this.notificationToSetAsRead.push(notification.id);
      });
      this.notificationToSetAsRead = this.notificationToSetAsRead.filter((element, index) => {
        return this.notificationToSetAsRead.indexOf(element) === index;
      });
    } else {
      this.notificationToSetAsRead = [];
    }
  }

  showVideo() {
    this._tutorialService.video_to_play = "Notifiche";
    this._tutorialService.force_open_modal = true;
  }
}
